import React from 'react';
import { LiveBetsContainer, userInfoStore, useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import MyBets from '../../../components/common/liveBets/myBets';
import OtherBets from '../../../components/common/liveBets/otherBets';
import { customLiveBetsSort } from '../../../helpers';
import { TranslationKeys } from '../../../enums';
import LiveBetsLoading from '../../../components/common/liveBetsLoading';
import { gameStore } from '../../../store';

export const LiveBetsWrapper = observer(() => {
  const t = useTranslation();
  const { currencySymbolOrCode } = userInfoStore;
  const { isLiveBetsLoader } = gameStore;

  return (
    <LiveBetsContainer
      renderMyLiveBetItem={(data, index, list) => {
        return <MyBets data={data || []} index={index} list={list} key={data?.id} t={t} />;
      }}
      renderOtherLiveBetItem={(data, index, list) => {
        return <OtherBets data={data || []} index={index} list={list} key={data?.id} t={t} />;
      }}
      customSortFunctional={customLiveBetsSort}
      liveBetsLoader={isLiveBetsLoader ? <LiveBetsLoading t={t} /> : null}
      headerNames={[
        { name: t(TranslationKeys.PlayerId) },
        { name: t(TranslationKeys.BetType) },
        { name: `${t(TranslationKeys.Amount)} (${currencySymbolOrCode})` },
        { name: `${t(TranslationKeys.Win)}  (${currencySymbolOrCode})` },
      ]}
    />
  );
});
